export default __webpack_public_path__ + "static/media/photo-16.777929b2.jpeg";